export type Environment = 'development' | 'staging' | 'preview' | 'production'
const isPreview = (env: Environment) => env === 'preview'
const isProduction = (env: Environment) => env === 'production'

export const isLive = (env: Environment) => isPreview(env) || isProduction(env)
